export const dollarize = (amount: number) => {
  return `$${amount / 100}`;
};
